import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getJsonValue } from "../utils/localstorage.util";
import useDuration from "../hooks/useDuration";

export default function GameResult() {
  const navigate = useNavigate();
  const duration = useDuration({ teamId: getJsonValue("TEAM").id });
  const restartGame = useCallback(() => {
    localStorage.clear();
    navigate("/");
  }, []);
  console.log(duration);
  return (
    <article className="result-container">
      <h2>Game Finished</h2>
      {duration && (
        <p>
          <i className="fa-solid fa-clock"></i>
          {!!duration?.minutes && <span> {duration?.minutes} M, </span>}
          <span> {duration?.seconds} sec</span>
        </p>
      )}
      <button
        onClick={() => {
          restartGame();
        }}
      >
        Restart
      </button>
    </article>
  );
}
